import { Box, BoxProps, ListItemButton, Stack } from '@mui/material';
import { TIcon } from 'modules/common/icons';

interface IWalletDropdownListItemProps {
  onClick: () => void;
  label: string;
  icon: TIcon;
  iconProps?: BoxProps;
}

export const WalletDropdownListItem = ({
  onClick,
  label,
  icon,
  iconProps,
}: IWalletDropdownListItemProps) => {
  return (
    <ListItemButton
      sx={{
        p: 1,
        borderRadius: theme => theme.spacing(0.8),
        fontSize: 16,
      }}
      onClick={onClick}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Box component={icon} width={20} {...iconProps} />
        {label}
      </Stack>
    </ListItemButton>
  );
};
